<template>
  <div class="emp-forma">
    <slot name="traka"></slot>
    <div v-if="poruka" class="forma-poruka" role="alert">
      <b>Spremanje nije uspjelo.</b> {{ poruka }}
    </div>
    <slot></slot>
  </div>
</template>

<script>
// Okvir novih obrazaca radnika: nosi CSS tokene i zajednički CSS, te "daje" stanje obrasca
// (greške, upozorenja, izmijenjena polja) kućicama FormaTraka / FormaTabovi / FormaKartica / FormaPolje
// preko provide/inject. Ne zna ništa o konkretnom obrascu.
export default {
  name: 'FormaOkvir',
  provide () {
    return { okvir: this }
  },
  props: {
    greske: { type: Object, default: () => ({}) }, // { Kljuc: poruka } — samo one koje se smiju vidjeti
    upozorenja: { type: Object, default: () => ({}) },
    izmijenjena: { type: Array, default: () => [] }, // ključevi polja različiti od izvornika
    redoslijed: { type: Array, default: () => [] }, // ključevi polja redom kako su na ekranu
    poruka: { type: String, default: '' } // greška sa servera
  },
  data () {
    return { dijelovi: [] }
  },
  computed: {
    brojGresaka () { return Object.keys(this.greske).length },
    brojUpozorenja () { return Object.keys(this.upozorenja).length },
    brojIzmjena () { return this.izmijenjena.length }
  },
  methods: {
    registriraj (c) { this.dijelovi.push(c) },
    odjavi (c) { this.dijelovi = this.dijelovi.filter(x => x !== c) },
    // otvori sve sklopive dijelove koji sadrže element (kartica, podskupina)
    otvoriZa (el) {
      this.dijelovi.forEach(c => { if (c.$el && c.$el.contains(el) && c.otvori) c.otvori() })
    },
    skociNaElement (el, fokus) {
      if (!el) return
      this.otvoriZa(el)
      this.$nextTick(() => {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        if (fokus) {
          const u = el.querySelector('input, select, textarea')
          if (u && u.focus) u.focus({ preventScroll: true })
        }
      })
    },
    skociNaPolje (kljuc) {
      this.skociNaElement(this.$el.querySelector('[data-polje="' + kljuc + '"]'), true)
    },
    skociNaKarticu (id) {
      this.skociNaElement(this.$el.querySelector('#' + id), false)
    },
    skociNaPrvu () {
      const g = this.greske
      const k = this.redoslijed.find(x => g[x]) || Object.keys(g)[0]
      if (k) this.skociNaPolje(k)
    }
  }
}
</script>

<style>
/* ---- tokeni i zajednički CSS za nove obrasce radnika (isti kao EmployeeViewNovi) ---- */
.emp-forma {
  --plava: #1976d2;
  --plava-tamna: #1565c0;
  --plava-svijetla: #eef4fb;
  --crta: rgba(0, 0, 0, 0.12);
  --sivo: rgba(0, 0, 0, 0.6);
  --zelena: #2e7d32;
  --crvena: #c62828;
  --narancasta: #ef6c00;
  --zuta: #f9a825;
  --izracun: #f3f5f7;
  --vrh: 60px; /* visina fiksne trake aplikacije */
  font-size: 15px;
}
.emp-forma .forma-poruka {
  background: #ffebee; border: 1px solid #ef9a9a; color: #b71c1c;
  border-radius: 4px; padding: 10px 14px; margin-bottom: 12px; font-size: 14px;
}

/* sticky traka + tabovi */
.emp-forma .forma-sticky { position: sticky; top: var(--vrh); z-index: 5; margin-bottom: 12px; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15); }
.emp-forma .traka {
  display: flex; align-items: center; gap: 10px 14px; flex-wrap: wrap;
  background: var(--plava); color: #fff; border-radius: 4px 4px 0 0; padding: 10px 14px;
}
.emp-forma .traka.bez-tabova { border-radius: 4px; }
.emp-forma .traka .avatar {
  width: 44px; height: 44px; border-radius: 50%; flex: none;
  background: rgba(255, 255, 255, 0.22); border: 2px solid rgba(255, 255, 255, 0.5);
  display: flex; align-items: center; justify-content: center; font-size: 17px; font-weight: 700;
}
.emp-forma .traka .naslov { font-size: 20px; font-weight: 700; line-height: 1.2; }
.emp-forma .traka .pod { font-size: 13px; opacity: 0.92; margin-top: 3px; }
.emp-forma .traka .razmak { flex: 1; }
.emp-forma .traka .stanja { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; }
.emp-forma .znak { font-size: 12px; font-weight: 500; border-radius: 10px; padding: 2px 10px; white-space: nowrap; border: 0; color: #fff; }
.emp-forma .znak.izmjene { background: var(--narancasta); }
.emp-forma .znak.greske { background: var(--crvena); cursor: pointer; text-decoration: underline; }
.emp-forma .znak.upoz { background: rgba(255, 255, 255, 0.28); }
.emp-forma .znak.cisto { background: rgba(255, 255, 255, 0.22); }
.emp-forma .traka .akcije { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; }
.emp-forma .gumb-bijeli.v-btn { background: #fff !important; color: var(--plava) !important; }
.emp-forma .gumb-duh.v-btn { border-color: rgba(255, 255, 255, 0.7); }
.emp-forma .tabovi {
  display: flex; gap: 2px; overflow-x: auto; white-space: nowrap;
  background: #fff; border: 1px solid var(--crta); border-top: 0; border-radius: 0 0 4px 4px; padding: 0 6px;
}
.emp-forma .tabovi a {
  display: inline-flex; align-items: center; gap: 6px; padding: 9px 14px; font-size: 14px; font-weight: 500;
  color: var(--sivo); text-decoration: none; border-bottom: 3px solid transparent; cursor: pointer;
}
.emp-forma .tabovi a:hover { color: var(--plava-tamna); background: var(--plava-svijetla); }
.emp-forma .tabovi a.akt { color: var(--plava-tamna); border-bottom-color: var(--plava); }
.emp-forma .tabovi .br { font-size: 11px; font-weight: 700; color: #fff; background: var(--crvena); border-radius: 9px; padding: 0 6px; min-width: 18px; text-align: center; }
.emp-forma .tabovi .bi { width: 7px; height: 7px; border-radius: 50%; background: var(--narancasta); display: inline-block; }

/* kartice */
.emp-forma .stupci { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; align-items: start; }
.emp-forma .kartica {
  background: #fff; border: 1px solid var(--crta); border-radius: 4px; margin-bottom: 12px;
  overflow: hidden; scroll-margin-top: 175px;
}
.emp-forma .naslov-kartice {
  font-size: 17px; font-weight: 700; letter-spacing: 0.02em; color: var(--plava-tamna);
  background: var(--plava-svijetla); border-bottom: 2px solid var(--plava);
  padding: 8px 16px; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;
}
.emp-forma .naslov-kartice .dodatak { font-size: 12px; font-weight: 400; color: var(--sivo); }
.emp-forma .naslov-kartice .strelica { margin-left: auto; font-size: 13px; color: var(--sivo); transition: transform 0.15s; }
.emp-forma .naslov-kartice .mali-znak { font-size: 11px; font-weight: 700; color: #fff; border-radius: 9px; padding: 0 7px; letter-spacing: 0; }
.emp-forma .naslov-kartice .mali-znak.gr { background: var(--crvena); }
.emp-forma .naslov-kartice .mali-znak.iz { background: var(--narancasta); }
.emp-forma .kartica.sklopiva > .naslov-kartice { cursor: pointer; user-select: none; }
.emp-forma .kartica.sklopiva:not(.otvoreno) > .naslov-kartice { border-bottom-color: var(--crta); }
.emp-forma .kartica.sklopiva:not(.otvoreno) > .naslov-kartice .strelica { transform: rotate(-90deg); }
.emp-forma .kartica.sklopiva:not(.otvoreno) > .tijelo { display: none; }
.emp-forma .tijelo { padding: 10px 16px 14px; }

.emp-forma .podnaslov {
  font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em;
  color: var(--plava-tamna); border-bottom: 1px solid var(--crta); padding-bottom: 2px;
  margin: 12px 0 8px; display: flex; gap: 8px; align-items: baseline;
}
.emp-forma .podsklop:first-child > .podnaslov, .emp-forma .tijelo > .podnaslov:first-child { margin-top: 0; }
.emp-forma .podnaslov .dodatak { font-size: 11px; font-weight: 400; text-transform: none; letter-spacing: 0; color: var(--sivo); }
.emp-forma .podnaslov .mali-znak { font-size: 11px; font-weight: 700; color: #fff; border-radius: 9px; padding: 0 7px; letter-spacing: 0; background: var(--crvena); }
.emp-forma .podsklop.sklopiva > .podnaslov { cursor: pointer; user-select: none; }
.emp-forma .podsklop > .podnaslov .strelica { margin-left: auto; font-size: 12px; color: var(--sivo); transition: transform 0.15s; }
.emp-forma .podsklop.sklopiva:not(.otvoreno) > .podnaslov .strelica { transform: rotate(-90deg); }
.emp-forma .podsklop.sklopiva:not(.otvoreno) > .sadrzaj { display: none; }

/* polja */
.emp-forma .mreza { display: grid; gap: 8px 12px; grid-template-columns: repeat(var(--n, 2), minmax(0, 1fr)); }
.emp-forma .mreza.c1 { --n: 1; }
.emp-forma .mreza.c3 { --n: 3; }
.emp-forma .mreza.c4 { --n: 4; }
.emp-forma .mreza .s2 { grid-column: span 2; }
.emp-forma .mreza .s3 { grid-column: span 3; }
.emp-forma .mreza .sve { grid-column: 1 / -1; }
.emp-forma .p { min-width: 0; }
.emp-forma .p > label.ol { display: flex; align-items: baseline; gap: 4px; font-size: 12px; color: var(--sivo); line-height: 1.25; margin-bottom: 2px; min-height: 15px; }
.emp-forma .p > label.ol i { color: var(--crvena); font-style: normal; font-weight: 700; }
.emp-forma .p .akcija { margin-left: auto; }
.emp-forma .p input[type=text], .emp-forma .p input[type=date], .emp-forma .p input[type=number],
.emp-forma .p select, .emp-forma .p textarea {
  width: 100%; font: inherit; font-size: 14.5px; color: inherit; background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.38); border-radius: 4px; padding: 5px 8px; height: 33px; outline: none;
}
.emp-forma .p textarea { height: auto; min-height: 56px; resize: vertical; }
.emp-forma .p input:hover, .emp-forma .p select:hover, .emp-forma .p textarea:hover { border-color: rgba(0, 0, 0, 0.7); }
.emp-forma .p input:focus, .emp-forma .p select:focus, .emp-forma .p textarea:focus { border-color: var(--plava); box-shadow: 0 0 0 1px var(--plava); }
.emp-forma .p input.n { text-align: right; font-variant-numeric: tabular-nums; }
.emp-forma .p .gr { color: var(--crvena); font-size: 12px; margin-top: 2px; line-height: 1.25; }
.emp-forma .p .up { color: #e65100; font-size: 12px; margin-top: 2px; line-height: 1.25; }
.emp-forma .p .ok { color: var(--zelena); font-size: 12px; margin-top: 2px; line-height: 1.25; }
.emp-forma .p .pomoc { font-size: 11.5px; color: var(--sivo); margin-top: 2px; line-height: 1.25; }
.emp-forma .p.greska input, .emp-forma .p.greska select, .emp-forma .p.greska textarea {
  border-color: var(--crvena); box-shadow: 0 0 0 1px var(--crvena); background: #fff6f6;
}
.emp-forma .p.upozorenje:not(.greska) input, .emp-forma .p.upozorenje:not(.greska) select { border-color: var(--zuta); }
.emp-forma .p.izm input[type=text], .emp-forma .p.izm input[type=date], .emp-forma .p.izm input[type=number],
.emp-forma .p.izm select, .emp-forma .p.izm textarea { border-left: 4px solid var(--narancasta); }
/* izračunato polje */
.emp-forma .p.izr input, .emp-forma .p.izr select {
  background: var(--izracun); border: 1px dashed #90a4ae; color: rgba(0, 0, 0, 0.75); cursor: not-allowed; box-shadow: none;
}
.emp-forma .p.izr > label.ol::after {
  content: "= računa se"; margin-left: auto; font-size: 10.5px; font-weight: 500; color: #546e7a;
  background: #e3e9ee; border-radius: 8px; padding: 0 6px; white-space: nowrap;
}
.emp-forma .tekst-gumb { background: none; border: 0; color: var(--plava); font-size: 12.5px; padding: 0 2px; text-decoration: underline; cursor: pointer; font-weight: 400; }
.emp-forma .tekst-gumb:disabled { color: rgba(0, 0, 0, 0.38); cursor: not-allowed; text-decoration: none; }
/* prekidač */
.emp-forma .sw { display: flex; align-items: center; gap: 8px; min-height: 33px; font-size: 14.5px; cursor: pointer; margin: 0; position: relative; }
.emp-forma .sw input { position: absolute; opacity: 0; pointer-events: none; }
.emp-forma .sw .tr { width: 34px; height: 16px; border-radius: 8px; background: #bdbdbd; position: relative; flex: none; transition: background 0.15s; }
.emp-forma .sw .tr::after {
  content: ""; position: absolute; top: -2px; left: -2px; width: 20px; height: 20px; border-radius: 50%;
  background: #fafafa; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4); transition: left 0.15s, background 0.15s;
}
.emp-forma .sw input:checked + .tr { background: #90caf9; }
.emp-forma .sw input:checked + .tr::after { left: 16px; background: var(--plava); }
.emp-forma .sw input:focus-visible + .tr { outline: 2px solid var(--plava); outline-offset: 3px; }
.emp-forma .sw small { color: var(--sivo); font-size: 12px; }
.emp-forma .p.izm .sw .tr { box-shadow: 0 0 0 2px var(--narancasta); }
.emp-forma .v-input { margin-top: 0; padding-top: 0; }

@media (max-width: 900px) {
  .emp-forma .stupci { grid-template-columns: 1fr; }
  .emp-forma .forma-sticky { position: static; }
  .emp-forma .traka .akcije { width: 100%; }
  .emp-forma .traka .razmak { display: none; }
  .emp-forma .kartica { scroll-margin-top: 20px; }
}
@media (max-width: 600px) {
  .emp-forma .mreza, .emp-forma .mreza.c3, .emp-forma .mreza.c4 { --n: 2; }
  .emp-forma .mreza .s3 { grid-column: 1 / -1; }
  .emp-forma .tijelo { padding: 10px 12px 12px; }
}
@media (max-width: 420px) {
  .emp-forma .mreza, .emp-forma .mreza.c3, .emp-forma .mreza.c4 { --n: 1; }
  .emp-forma .mreza .s2 { grid-column: 1 / -1; }
}
</style>
